import { endpoints, request } from '!core/api';

export const trlOTPDeliveryMethodServices = {
  getDeliveryMethods: () =>
    request.get(endpoints.chnn('GetNotificationTypes?scopeId=OTP')),
};
